// ライブラリの宣言
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

// 各コンポーネントを以下のファイルのクラスから呼んでいる
import Nav from "./components/Nav";
import Cards from "./components/Cards";
import Panel from "./components/Panel";
import FloatBtn from "./components/FloatBtn";

// 一番親、メインのクラス。ここに全てが集約される
class App extends React.Component{
  constructor(props){
    super(props);
    this.state={
      loading: true,
      jsonData: null,
      panel: null,
      getPanelTitle: null
    }
    this.getPanelTitle = this.getPanelTitle.bind(this);
    this.panelHandle = this.panelHandle.bind(this);
    
  }
  
  componentDidMount(){
    // ajaxでjsonファイルを読む
    return fetch('https://lp.toranoana.shop/untill_now_campaign/campaignList.json',{
      cache: "no-cache"
    }).then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          jsonData: responseJson
        });
      })
      .catch((error) =>{
        console.error(error);
      });
  }
  
  // 子コンポーネントでこの親クラスのstateを操作するための関数
  panelHandle(e){
    this.setState({ panel: e });
  }
  // 子コンポーネントでこの親クラスのstateを操作するための関数
  getPanelTitle(e){
    this.setState({ getPanelTitle: e });
  }
  
  // HTMLをレンダリング
  render(){
    return (
      <div id="wrapper">
        {(() => { 
          if(!this.state.jsonData){
            return <div id="wrapper__loading"></div>
          }
        })()}
        <div id="main">
          <Nav />
          <section id="top">
            <div id="top__wrapper" className="top__wrapper">
              <h1 data-content="とらのあな通信販売、今までの">キャンペーンまとめ</h1>
            </div>
          </section>
          <Panel jsonData={ this.state.jsonData } panelHandle = { this.panelHandle } />
          <Cards jsonData={ this.state.jsonData } panelHandle = { this.state.panel } />
        </div>
        <FloatBtn />
        <footer><small>© 株式会社とらのあな</small></footer>
      </div>
    );
  }
}

export default App;
